<template>
    <div>
        <slot name="section"></slot>
        <b-card no-body>
            <b-tabs card v-model="tabIdx">
                <b-tab title="Address" active>
                    <b-card-body>
                        <b-form @submit.stop.prevent="onSubmit">
                            <b-form-row>

                                <b-col
                                    v-for="(d_item, i) in dataItems"
                                    :key="i + 'data'"
                                    cols="6"
                                >
                                    <b-form-group
                                        v-if="
                                            !(
                                                (d_item.field === 'name' ||
                                                    d_item.field ===
                                                        'is_warehouse') &&
                                                sectionOnly
                                            )
                                        "
                                        :id="d_item.field"
                                        :label="
                                            capitalCase(d_item.field) +
                                            (d_item.required ? '*' : '')
                                        "
                                        :label-for="'input-' + d_item.field"
                                    >
                                        <b-form-input
                                            v-if="d_item.type === 'text'"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :readonly="
                                                !!d_item.readonly || isReadOnly
                                            "
                                            trim
                                        ></b-form-input>

                                        <b-form-select
                                            v-if="
                                                d_item.field === 'country_code'
                                            "
                                            :disabled="isReadOnly"
                                            value-field="value"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            @change="fetchState(d_item, $event)"
                                            :options="getData(d_item.field)"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                >
                                                    Select Country
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>

                                        <b-form-select
                                            v-if="d_item.field === 'state_name'"
                                            :disabled="isReadOnly"
                                            value-field="text"
                                            :id="'input-' + d_item.field"
                                            v-model="model[d_item.field]"
                                            :required="d_item.required"
                                            :options="getData(d_item.field)"
                                        >
                                            <template #first>
                                                <b-form-select-option
                                                    :value="null"
                                                    selected
                                                >
                                                    Select State
                                                </b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <!-- <b-form-select v-if="d_item.field === 'city'" :disabled="isReadOnly"
                                            value-field="text"
                                            :id="'input-' + d_item.field" v-model="model[d_item.field]"
                                            :required="d_item.required" :options="getData(d_item.field)">
                                            <template #first>
                                                <b-form-select-option :value="null" disabled selected>
                                                    Select City
                                                </b-form-select-option>
                                            </template></b-form-select> -->
                                        <b-form-checkbox
                                            v-if="
                                                d_item.type === 'check' &&
                                                !sectionOnly
                                            "
                                            :id="'input-' + d_item.field"
                                            :disabled="viewable"
                                            v-model="model[d_item.field]"
                                            :name="'input-' + d_item.field"
                                            :value="1"
                                            :unchecked-value="0"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col>
                                    <b-button-group size="sm">
                                        <b-button v-if="!hideControls" variant="secondary" :disabled="!!loading"
                                            @click="$router.go(-1)">Cancel</b-button>

                                        <b-button v-if="!hideControls" type="submit" variant="primary"
                                            :disabled="!!loading">{{ submitLabel }}</b-button>

                                        <b-button v-if="!hideControls && this.model.id
                                            " @click="deleteLocation()" class="mr-2" variant="warning"
                                            v-show="hasPermissionDelete">
                                            Delete Location
                                        </b-button>
                                        <slot v-bind:default="model"></slot>
                                    </b-button-group>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-tab>
                <b-tab title="Map">
                    <b-card-body>
                        <location-picker v-if="tabIdx == 1" title="Map Location" :location="mapLocation"
                            @set-location="coords => setCoordinates(coords)"
                            @get-location="locationdata => getLocation(locationdata)" />
                    </b-card-body>
                </b-tab>
                <b-tab title="Sections" v-if="!sectionOnly && !!model.id">
                    <b-card-body>
                        <b-form inline>
                            <label class="sr-only" for="inline-form-input-name">Section Name</label>
                            <b-form-input size="sm" id="inline-form-input-name" class="mb-2 mr-sm-2 mb-sm-0"
                                placeholder="Section Name" v-model="section.name"></b-form-input>

                            <b-button size="sm" variant="primary" @click="saveSection(section)">Add Section</b-button>
                        </b-form>

                        <b-table :fields="sectionFields" striped hover :items="sections">
                            <template #cell(name)="row">
                                <b-form-input :id="row.index + 'name'" v-model="row.item.name"></b-form-input>
                            </template>
                            <template #cell(is_officer)="row">
                                <b-form-checkbox :id="row.index + '-is_officer'" v-model="row.item.is_officer"
                                    :name="row.index + '-is_officer'" :value="1" :unchecked-value="0">
                                </b-form-checkbox>
                            </template>
                            <template #cell(id)="row">
                                <b-button size="sm" @click="saveSection(row.item)" class="mr-2" variant="primary">
                                    Save
                                </b-button>

                                <b-button size="sm" @click="deleteSection(row.item.id)" class="mr-2" variant="warning">
                                    Delete
                                </b-button>
                            </template>
                        </b-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script lang="js">
import { debounce } from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import LocationPicker from '@/components/Map/LocationPicker'


const dataItems = Object.freeze([{
    field: 'name',
    type: 'text',
    required: true
},
{
    field: 'is_warehouse',
    type: 'check',
    required: false
},
{
    field: 'country_code',
    type: 'select',
    required: true
},
{
    field: 'map_reference',
    type: 'text',
    required: false
},
{
    field: 'address1',
    type: 'text',
    required: true
},
{
    field: 'address2',
    type: 'text',
    required: false
},
// {
//     field: 'city',
//     type: 'text',
//     required: true
// },
{
    field: 'state_name',
    type: 'select',
    required: true
},
{
    field: 'city',
    type: 'text',
    required: true
},
{
    field: 'postal_code',
    type: 'text',
    required: false
},
{
    field: 'zip_code',
    type: 'text',
    required: false
},
{
    field: 'latitude',
    type: 'text',
    readonly: true,
    required: false
},
{
    field: 'longitude',
    type: 'text',
    readonly: true,
    required: false
},
])

const generateEmptyForm = () => {
    return dataItems.reduce(
        (_form, item) => {
            switch (item.field) {
                case 'country_code':
                    _form.country_code = 'JM'
                    break
                default:
                    _form[item.field] = item.type == 'check' ? false : null
                    break
            }
            return _form
        }, {
        id: 0
    }
    )
}

const L = window.L
const model = generateEmptyForm()
const default_coords = {
    latitude: 18.002804952844535,
    longitude: -76.78970255393327,
}
/////default

export default {
    name: 'locations-view',
    components: {
        LocationPicker
    },
    data() {
        return {
            tabIdx: 0,
            updatedDataItems: [],
            model,
            hasErrors: false,
            section: {
                name: null
            },

            sectionFields: [
                'name',
                'is_officer',
                {
                    key: 'id',
                    label: 'Controls',
                },
            ],
        }
    },
    props: {
        id: {
            type: Number,
            default: 0
        },
        sectionOnly: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        hideControls: {
            type: Boolean,
            default: false
        },
        locationData: {
            type: Object,
            default: () => null,
        },
    },
    mixins: [popupMixins, permissionsMixins],
    computed: {
        isReadOnly() {
            return !!(this.sectionOnly && this.model.id)
        },
        viewable() {
            return !!this.model.id
        },
        dataItems() {
            return [...dataItems].filter(
                x =>
                    !(
                        (x.field === 'name' || x.field === 'is_warehouse') &&
                        this.sectionOnly
                    )
            )
        },
        title() {
            return this.model.id ? 'Edit Location' : 'Add Location'
        },
        sections() {
            return this.$store.getters['locations/sections']
        },

        simpleLocation() {
            return this.$store.getters['locations/simpleLocation']
        },
        mapLocation() {
            const _location = {
                ...(this.model || {})
            }
            let {
                latitude,
                longitude
            } = _location
            latitude = isNaN(parseFloat(latitude)) ? default_coords.latitude : parseFloat(latitude)
            longitude = isNaN(parseFloat(longitude)) ? default_coords.longitude : parseFloat(longitude)
            try {
                if (
                    !(
                        latitude > -90 &&
                        latitude < 90 &&
                        longitude > -180 &&
                        longitude < 180
                    )
                ) {
                    console.log('invalid coordinates', {
                        latitude,
                        longitude,
                    })
                    throw new Error('Invalid Coordinates')
                }
            } catch (error) {
                console.error('mapLocation', error)
                ////////
                latitude = default_coords.latitude
                longitude = default_coords.longitude
            }

            const center = new L.latLng(latitude, longitude)
            this.$set(_location, 'lat', latitude)
            this.$set(_location, 'lng', longitude)
            this.$set(_location, 'center', center)
            return _location
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {
        sections: {
            handler: function () { },
            deep: true,
        },
        simpleLocation: {
            handler: function (_location) {
                this.model = {
                    ..._location
                }
                //console.log('watched simpleLocation-', _location)
            },
            deep: true,
        },

        'model.name': debounce(function (val) {
            this.$set(this.model, 'name', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.is_warehouse': function (val) {
            this.$set(this.model, 'is_warehouse', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        },

        'model.address1': debounce(function (val) {
            this.$set(this.model, 'address1', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.address2': debounce(function (val) {
            this.$set(this.model, 'address2', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.city': debounce(function (val) {
            this.$set(this.model, 'city', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),
        'model.state_name': debounce(function (val) {
            this.$set(this.model, 'state_name', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.postal_code': debounce(function (val) {
            this.$set(this.model, 'postal_code', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        'model.country_code': function (val) {
            //this.$store.dispatch('locations/fetchstate', { val })
            this.$set(this.model, 'country_code', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        },

        'model.map_reference': debounce(function (val) {
            this.$set(this.model, 'map_reference', val)
            this.$nextTick(() => {
                this.fetchCoordinates()
            })
        }, 500),

        id: function (id) {
            this.setLocation(id).then()
        },
        locationData: function (_data) {
            this.setLocation(this.id, _data)
        },
    },

    async mounted() {
        await this.setLocation(this.id, this.locationData)
        const country_code = await this.model.country_code
        this.$store.dispatch('locations/fetchstate', { country_code })
    },
    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchCountry')
    },

    methods: {
        clearModel() {
            this.model = generateEmptyForm()
        },
        async setLocation(id, data) {
            try {
                if (id) {
                    await this.$store.dispatch('locations/fetchById', id)
                    await this.$nextTick()
                    this.model = {
                        ...this.simpleLocation
                    }
                } else if (data) {
                    this.model = {
                        ...data
                    }
                } else {
                    this.clearModel()
                }
            } catch (error) {
                this.isError = true
            }
        },
        setCoordinates(coords) {
            const {
                lat: latitude,
                lng: longitude
            } = coords
            if (!this.isReadOnly) {
                this.$set(this.model, 'latitude', latitude)
                this.$set(this.model, 'longitude', longitude)
            }
        },

        getLocation(locationData) {
            const country_code = locationData.data.results[0].components.country_code.toUpperCase()
            this.$set(this.model, 'city', locationData.data.results[0].components.city)
            this.$set(this.model, 'state_name', locationData.data.results[0].components.state)
            this.$set(this.model, 'country_code', locationData.data.results[0].components.country_code.toUpperCase())
            this.$store.dispatch('locations/fetchstate', { country_code })
            this.$set(this.model, 'address1', (locationData.data.results[0].components.suburb) ? locationData.data.results[0].components.suburb : locationData.data.results[0].components.suburb)
            if (country_code === "US" || country_code === "PH") {
                this.$set(this.model, 'zip_code', locationData.data.results[0].components.postcode)
            } else {
                this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)
            }
            // this.$set(this.model, 'postal_code', locationData.data.results[0].components.postcode)

        },

        async fetchCoordinates() {
            if (this.isReadOnly) return
            let coords = {
                latitude: 0,
                longitude: 0
            }
            try {
                const {
                    country_code,
                    city,
                    address1, state
                } = this.model

                // console.log("this.model.......",this.model)
                if (!(country_code || city || address1 || state))
                    throw new Error('Invalid Address!')

                coords = await this.$store.dispatch(
                    'locations/geocodeAddress',
                    this.model
                )
            } catch (err) {
                //console.log('fetchCoordinates error', err)
            } finally {
                for (const key in coords) {
                    this.$set(this.model, key, coords[key])
                }
                this.$emit('update-location-model', {
                    ...this.model
                })
            }
        },

        capitalCase(data) {
            if (data == 'country_code') return 'Country/Region'
            if (data == 'postal_code') return 'Post Office/District Code'
            if (data == 'state_name') return 'State/Province/Region/Parish'
            const list = data.split('_')
            if (list[list.length - 1] === 'id') {
                list.pop()
            }
            return list
                .map(
                    x => x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase()
                )
                .join('  ')
        },
        getData(field) {
            return (() => {
                switch (field) {
                    case 'country_code':
                        return this.$store.state.locations.country
                    case 'state_name':
                        return this.$store.state.locations.states
                }
            })()
        },


        deleteLocation() {
            const model = {
                ...this.model
            }
            this.$emit('delete-location', model.id)
        },
        async onSubmit() {
            const model = {
                ...this.model
            }

            // console.log("......model........", model)

            if (!model.latitude || !model.longitude) {
                this.doToast(
                    'Error!',
                    "Latitude and Longitude missing. Please enter a valid address then click 'find address' on the Map",
                    'danger'
                )
                return
            }

            if (this.sectionOnly && !model.id) {
                model.name = model.name || Date.now().toString(36)
                model.is_warehouse = false
            }
            model.is_warehouse = !!model.is_warehouse
            const valid = await this.$validator.validate()

            if (!valid) {
                this.doToast('Error!', 'Entry not Valid', 'danger')
                return
            }
            if (valid) {
                this.$emit('save-location', model)
            }
        },
        fetchState(item, event) {
            this.model.state = null;
            const country_code = event
            this.$store.commit('locations/SET_STATES', null);
            this.$store.dispatch('locations/fetchstate', { country_code })
        },

        saveSection(section) {
            const {
                id: location_id
            } = this.simpleLocation
            this.$emit('save-section', {
                section,
                location_id
            })
        },
        deleteSection(id) {
            const location_id = this.simpleLocation.id
            this.$emit('delete-section', {
                id,
                location_id
            })
        },
    },
}
</script>
<style></style>
